import "core-js/modules/es.array.map";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { customPaging, reservation } from "@/mixins/index";
import uploadImagetow from '@/components/uploadImagetow';
export default {
  name: "dailyWelfare",
  mixins: [customPaging, reservation],
  components: {
    uploadImagetow: uploadImagetow
  },
  data: function data() {
    return {
      pagingReqFn: "WelfarlotteryCodeData",
      pagingReqValue: "",
      drawer: false,
      delIds: [],
      tableData: [],
      paramsData: {
        item_id: ''
      }
    };
  },
  created: function created() {
    this.paramsData.item_id = this.dailyWelFareitemList[0].value;
  },
  methods: {
    getList: function getList() {
      var _this = this;

      this.$api.WelfarlotteryCodeData(this.paramsData).then(function (res) {
        if (res.code == 0) {
          _this.currentPage = 1;
          var lists = [];
          res.data.map(function (item, index) {
            lists.push({
              code: item,
              index: index + 1
            });
          });
          _this.PrimitiveData = lists;
          _this.tableCopyTableList = JSON.parse(JSON.stringify(lists));
          _this.tableData = _this.currentChangePage(_this.pageSize, _this.currentPage);
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    viewOpen: function viewOpen(content) {
      this.content = this.$utils.textRepl(content);
      this.drawer = true;
    }
  }
};